import {
  datePickerFormat,
  datePickerPlaceholderFormat,
} from "../../utils/functions";
import { create } from "zustand";

const en_us: { [key: string]: string } = {
  finalise: "finalize",
  Finalise: "Finalize",
  unfinalise: "unfinalize",
  Unfinalise: "Unfinalize",
  Finalised: "Finalized",
  Unfinalised: "unFinalized",
  colour: "color",
  Colour: "Color",
  centre: "center",
  Centre: "Center",
  catalogue: "catalog",
  Catalogue: "Catalog",
  vat: "tax",
  Vat: "Tax",
  summarise: "summarize",
  Summarise: "Summarize",
  Authorised: "Authorized",
  authorised: "authorized",
  optimise: "optimize",
  Optimise: "Optimize",
  analyse: "analyze",
  Analyse: "Analyze",
};

const en_gb: { [key: string]: string } = {
  vat: "VAT",
  Vat: "VAT",
};

const getTranslate = (locale: string, value: string): string => {
  switch (locale) {
    case "en-us":
      return en_us[value] || value;
    case "en-gb":
      return en_gb[value] || value;
    default:
      return value;
  }
};

interface TranslatorInterface {
  locale: string;
  placeholderDate: string;
  dateFormat: string;
  changeLocale: (value: string) => void;
  t: (value: string) => string;
}

export const useTranslatorStore = create<TranslatorInterface>((set, get) => ({
  locale: "en-gb",
  placeholderDate: "dd/mm/yyyy",
  dateFormat: "d/m/y",
  changeLocale: (value: string) => {
    set({ locale: value });
    set({ placeholderDate: datePickerPlaceholderFormat(value) });
    set({ dateFormat: datePickerFormat(value) });
  },
  t: (value: string): string => {
    if (!value) return value;
    const locale = get().locale;
    return getTranslate(locale, value);
  },
}));
